module.exports = __webpack_public_path__ + "img/data.8b11348c.svg";